/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react';
import Button from '@/components/Button/Button';
import Modal from '@/components/Modal/Modal';
import Table from '@/components/Tables/Table/Table';
import Link from '@/components/Link/Link';
import styles from './EditLinkedBundlesModal.module.css';
import { EditLinkedBundleSettingsModalProps } from './EditLinkedBundleModal.types';
import { LinkedBundles } from '@/types/bundles.types';
import { CellContext } from '@tanstack/react-table';
import { ButtonVariants } from '@/components/Button/Button.types';
import { useUnlinkBundles } from '@/services/bundles/bundles.service';

const ViewBundle = ({ row }: CellContext<LinkedBundles, unknown>) => (
  <Link to={`/bundles/${row.original.id}`}>{row.original.code || '-'} </Link>
);

const EditLinkedBundlesModal: FC<EditLinkedBundleSettingsModalProps> = ({ isOpen, onClose, detail, bundleName }) => {
  const [confirmUnlink, setConfirmUnlink] = useState(false);

  const { mutate } = useUnlinkBundles();

  useEffect(() => {}, [isOpen]);

  const handleConfirmUnlink = () => {
    window.location.reload();
    mutate(
      { bundleName },
      {
        onSuccess: () => {
          setConfirmUnlink(false);
        },
      },
    );
    onClose();
  };

  return (
    <>
      {!confirmUnlink && (
        <Modal
          className={styles.editLinkedBundleModal}
          isOpen={isOpen}
          onClose={() => {
            onClose();
          }}
          headerContent={bundleName}
          showTitleDivider
          maxWidth="610px"
          bodyContent={
            <div className={styles.body}>
              <Table
                includeMinWidth={false}
                height={detail.length > 5 ? '300px' : undefined}
                data={detail || []}
                columns={[
                  {
                    accessorKey: 'code',
                    header: 'BUNDLE CODE',
                    cell: ViewBundle,
                  },
                  {
                    header: 'DISPLAY NAME',
                    accessorKey: 'name',
                  },
                  {
                    header: 'BUNDLE DESC.',
                    accessorKey: 'internalName',
                  },
                ]}
              />
              <div className={styles.centralizeLink}>
                <button className={styles.unlinkBundles} type="button" onClick={() => setConfirmUnlink(!confirmUnlink)}>
                  Unlink all Bundles
                </button>
              </div>
            </div>
          }
          footerContent={
            <div className={styles.footer}>
              <div className={styles.buttonContainer}>
                <Button onClick={onClose}>Close</Button>
              </div>
            </div>
          }
        />
      )}
      {confirmUnlink && (
        <Modal
          className={styles.confirmUnlinkModal}
          isOpen={isOpen}
          onClose={() => {
            onClose();
            setConfirmUnlink(!confirmUnlink);
          }}
          headerContent="Are you sure you want to unlink these bundles?"
          footerContent={
            <div className={styles.modalButtons}>
              <Button
                variant={ButtonVariants.Secondary}
                onClick={() => {
                  onClose();
                  setConfirmUnlink(false);
                }}
                type="button"
              >
                Cancel
              </Button>
              <Button onClick={handleConfirmUnlink}>Confirm</Button>
            </div>
          }
        />
      )}
    </>
  );
};

export default EditLinkedBundlesModal;
